import React from "react";

import Button from "@atoms/Button";

interface IProps {
  removeDisabled?: boolean;
  quantity: number;
  handleChange: (num: number) => void;
  quantityAvailable?: number;
}

export default function Stepper({ removeDisabled, quantity, handleChange, quantityAvailable = 99 }: IProps) {
  const handleQuantity = (type: "add" | "remove") => {
    if (type === "add") {
      if (quantityAvailable >= quantity) {
        handleChange(quantity + 1);
      }
    }

    if (type === "remove") {
      handleChange(quantity - 1);
    }
  };

  return (
    <div className="pc:h-8.25 flex h-7.5 w-fit items-center gap-1 bg-[oklch(0.84_0_0_/_0.4)] text-black">
      <Button
        as="text"
        className="w-6 justify-center text-black!"
        disabled={removeDisabled}
        onClick={() => {
          handleQuantity("remove");
        }}
      >
        -
      </Button>
      <span className="w-6 text-center">{quantity}</span>
      <Button
        as="text"
        className="w-6 items-center justify-center text-black!"
        onClick={() => {
          handleQuantity("add");
        }}
      >
        +
      </Button>
    </div>
  );
}
